<div
  class="message-item"
  [class.message-item--mine]="isMine"
  [class.message-item--other]="!isMine"
  [class.message-item--deleted]="message.is_deleted"
  [class.message-item--compact]="compact"
  [class.message-item--group]="isGroupChat"
  (mouseenter)="showActions = true"
  (mouseleave)="showActions = false"
>
  <!-- Avatar only in group chats -->
  <div class="mi-avatar" *ngIf="!isMine && isGroupChat && showAvatar">{{ senderInitials }}</div>
  <div class="mi-avatar-spacer" *ngIf="!isMine && isGroupChat && !showAvatar"></div>

  <!-- Content -->
  <div class="mi-body">
    <div class="mi-meta">
      <span class="mi-sender" *ngIf="!isMine && isGroupChat && showSender">{{ senderName }}</span>
      <span class="mi-time" [title]="formattedDate">{{ formattedTime }}</span>
      <span *ngIf="message.is_edited" class="mi-edited">(edited)</span>
      <span
        *ngIf="showDeliveryStatus"
        class="mi-delivery"
        [class.mi-delivery--failed]="message.delivery_status === 'failed'"
        [class.mi-delivery--queued]="message.delivery_status === 'queued'"
      >
        <i
          *ngIf="message.delivery_status === 'sending'"
          class="pi pi-spin pi-spinner"
          aria-hidden="true"
        ></i>
        <i
          *ngIf="message.delivery_status === 'queued'"
          class="pi pi-clock"
          aria-hidden="true"
        ></i>
        <button
          *ngIf="message.delivery_status === 'failed'"
          type="button"
          class="mi-retry-btn"
          (click)="onRetryClick($event)"
          aria-label="Retry sending message"
        >
          <i class="pi pi-refresh" aria-hidden="true"></i>
          Retry
        </button>
        <span *ngIf="message.delivery_status !== 'failed'" class="mi-delivery-label">
          {{ deliveryLabel }}
        </span>
      </span>
    </div>

    <div
      class="mi-bubble"
      [class.mi-bubble--deleted]="message.is_deleted"
      [class.mi-bubble--pending]="showDeliveryStatus"
    >
      <div
        *ngIf="!message.is_deleted"
        class="mi-text"
        [innerHTML]="formattedMessageHtml"
      ></div>
      <div *ngIf="message.is_deleted" class="mi-deleted">This message was deleted.</div>

      <!-- File/image/video attachment -->
      <div *ngIf="message.attachment_url && !message.is_deleted" class="mi-attachment">
        <div
          *ngIf="isImage && attachmentPresignedUrl"
          class="mi-img-wrap"
        >
          <img
            [src]="attachmentPresignedUrl"
            [alt]="message.attachment_name || 'attachment'"
            class="mi-img"
            (click)="openImagePreview($event)"
          />
          <div class="mi-img-overlay">
            <button
              type="button"
              pButton
              icon="pi pi-eye"
              class="p-button-rounded p-button-text mi-img-action-btn"
              (click)="openImagePreview($event)"
              pTooltip="View"
              tooltipPosition="top"
            ></button>
            <button
              type="button"
              pButton
              icon="pi pi-download"
              class="p-button-rounded p-button-text mi-img-action-btn"
              [disabled]="downloadingAttachment"
              (click)="downloadAttachment($event)"
              pTooltip="Download"
              tooltipPosition="top"
            ></button>
          </div>
        </div>
        <video
          *ngIf="isVideo && attachmentPresignedUrl"
          [src]="attachmentPresignedUrl"
          controls
          preload="metadata"
          class="mi-video"
        >
          Your browser does not support video playback.
        </video>
        <a
          *ngIf="!isImage && !isVideo && attachmentPresignedUrl"
          [href]="attachmentPresignedUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="mi-file"
        >
          <i class="pi" [ngClass]="isPdf ? 'pi-file-pdf' : 'pi-file'"></i>
          <span>{{ message.attachment_name || 'Attachment' }}</span>
        </a>
      </div>
    </div>

    <!-- Reactions -->
    <div *ngIf="reactionEntries.length > 0" class="mi-reactions">
      <button
        *ngFor="let r of reactionEntries"
        class="mi-reaction-pill"
        [class.mi-reaction-pill--mine]="r.hasMe"
        (click)="onReact(r.emoji)"
      >
        {{ r.emoji }} {{ r.count }}
      </button>
    </div>

    <!-- Thread count -->
    <button
      *ngIf="message.thread_count > 0 && !message.parent_message_id"
      class="mi-thread-link"
      (click)="openThread.emit()"
    >
      <i class="pi pi-comments"></i>
      {{ message.thread_count }} {{ message.thread_count === 1 ? 'reply' : 'replies' }}
    </button>
  </div>

  <!-- Hover actions -->
  <div class="mi-actions" *ngIf="showActions && !message.is_deleted">
    <button
      *ngFor="let emoji of COMMON_EMOJIS"
      class="mi-action-emoji"
      (click)="onReact(emoji)"
      [title]="'React with ' + emoji"
    >
      {{ emoji }}
    </button>
    <button
      *ngIf="!message.parent_message_id"
      class="mi-action-btn"
      (click)="openThread.emit()"
      title="Reply in thread"
    >
      <i class="pi pi-comment"></i>
    </button>
  </div>
</div>

<p-dialog
  header="Image preview"
  [(visible)]="previewDialogVisible"
  [closable]="true"
  closeIcon="pi pi-times"
  closeAriaLabel="Close preview"
  [modal]="true"
  [dismissableMask]="true"
  appendTo="body"
  [style]="{ width: 'min(92vw, 720px)' }"
  [contentStyle]="{ overflow: 'auto', maxHeight: '80vh' }"
  (onHide)="closeImagePreview()"
>
  <img
    *ngIf="attachmentPresignedUrl"
    [src]="attachmentPresignedUrl"
    [alt]="message?.attachment_name || 'attachment'"
    class="mi-preview-img"
  />
  <ng-template pTemplate="footer">
    <button
      type="button"
      pButton
      label="Cancel"
      class="cancel-btn p-button-outlined p-button-sm"
      [disabled]="downloadingAttachment"
      (click)="previewDialogVisible = false;"
    ></button>
    <button
      type="button"
      pButton
      label="Download"
      class="save-btn ms-2 p-button-outlined p-button-sm"
      [disabled]="downloadingAttachment"
      (click)="downloadAttachment()"
    ></button>
    <!-- <button
      type="button"
      pButton
      label="Open in new tab"
      icon="pi pi-external-link"
      class="p-button-text p-button-sm"
      (click)="openAttachmentInNewTab()"
    ></button> -->
  </ng-template>
</p-dialog>
